export const roundToFourDecimals = (value?: number | string) => {
  if (!value) return value

  const factor = 10000
  return Math.round(Number(value) * factor) / factor
}

export const roundToDecimals = (
  value: number | string,
  decimals: number = 2,
): number => {
  const factor = Math.pow(10, decimals)
  return Math.round(Number(value) * factor) / factor
}
